import React, { useState } from 'react';
import CustomModal from '../../../../components/CustomModal';
import Welcome from './Welcome';
import Details from './Details';
import Success from './Success';
import { Drawer, useMediaQuery } from '@mui/material';
import { theme } from '../../../../components/theme/theme';
import ConnectErrorScreen from './ConnectErrorScreen';
import { useTreasuryAccounts } from '../../../../customhooks/treasury/useTreasuryAccounts';

interface ConnectBankModalProps {
    open: boolean;
    onClose: () => void;
}

const ConnectBankModal: React.FC<ConnectBankModalProps> = ({
    open,
    onClose
}) => {
    const [step, setStep] = useState<1 | 2 | 3 | 4>(1);
    const [prevSep, setPrevStep] = useState<1 | 2 | 3 | 4 | undefined>(
        undefined
    );
    const {refetchAccounts} = useTreasuryAccounts();

    const handleClose = () => {
        setStep(1);
        onClose();
        refetchAccounts();
    };

    const stepList: Record<1 | 2 | 3 | 4, JSX.Element> = {
        1: <Welcome onContinue={() => setStep(2)} />,
        2: <Details onContinue={() => setStep(3)} />,
        3: <Success onContinue={handleClose} />,
        4: (
            <ConnectErrorScreen
                onClose={handleClose}
                prevStep={prevSep}
                setStep={setStep}
            />
        )
    };
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {isMobile ? (
                <Drawer
                    anchor={'bottom'}
                    open={open}
                    onClose={() => {
                        setPrevStep(step);
                        setStep(4);
                    }}
                    sx={{
                        '.MuiDrawer-paperAnchorRight': {
                            width: {
                                xs: '95%',
                                lg: '33rem'
                            }
                        }
                    }}
                >
                    {stepList[step]}
                </Drawer>
            ) : (
                <CustomModal
                    maxWidth='470px'
                    open={open}
                    onClose={() => {
                        setPrevStep(step);
                        setStep(4);
                    }}
                    title=''
                >
                    {stepList[step]}
                </CustomModal>
            )}
        </>
    );
};

export default ConnectBankModal;
